import { render } from "./HorizontalLayout.vue?vue&type=template&id=44fd3908&scoped=true"
import script from "./HorizontalLayout.vue?vue&type=script&lang=js"
export * from "./HorizontalLayout.vue?vue&type=script&lang=js"

import "./HorizontalLayout.vue?vue&type=style&index=0&id=44fd3908&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44fd3908"]])

export default __exports__